module.exports = __webpack_public_path__ + "static/IMG-20200816-WA0017-cf591a171fc41ea1a4d46f4c17532572.jpg";